/** Detect random-keyboard / bot demo requests like mixed-case gibberish names. */
export function looksLikeGibberish(value) {
  if (!value || typeof value !== "string") return false;

  const letters = value.trim().replace(/[^a-zA-Z]/g, "");
  if (letters.length < 10) return false;

  let caseSwitches = 0;
  for (let i = 1; i < letters.length; i += 1) {
    const prevUpper = letters[i - 1] === letters[i - 1].toUpperCase();
    const currUpper = letters[i] === letters[i].toUpperCase();
    if (prevUpper !== currUpper) caseSwitches += 1;
  }
  if (letters.length >= 12 && caseSwitches / (letters.length - 1) >= 0.35) {
    return true;
  }

  const vowels = (letters.match(/[aeiouAEIOU]/g) || []).length;
  if (vowels / letters.length < 0.18) return true;

  return /[bcdfghjklmnpqrstvwxyz]{6,}/i.test(letters);
}

export function isSpamDemoRequest({ name, restaurant, message, website, submittedTooFast }) {
  if (website && String(website).trim()) return true;
  if (submittedTooFast) return true;
  if (looksLikeGibberish(name) || looksLikeGibberish(restaurant)) return true;
  if (message && /^\d{6,}$/.test(String(message).trim())) return true;
  return false;
}
